/**
 * @author: subhasish.ghosh@zoom.us
 */

import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Box,
  DialogTitle,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { productCatalogActionColumns } from "@options/dataGrid";
import React, { useEffect, useState } from "react";
import "./styles.css";

const ProductCatalogActionFailureReasonModal = ({ isOpen, onClose, data }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const cleanUp = () => {
    setOpen(false);
  };

  const handleClose = () => {
    cleanUp();
    onClose(false);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        className="product-catalog-action-failure-modal"
      >
        <Box
          className="product-catalog-action-failure-box"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <DialogTitle id="modal-title" style={{ padding: 0 }}>
            <Box display="flex" justifyContent="space-between">
              <Typography
                id="modal-title"
                variant="h6"
                component="h2"
                style={{ fontWeight: "bold" }}
              >
                {`Product Catalog Action Failures`}
              </Typography>
              <Box>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </DialogTitle>
          <Box sx={{ height: 400, width: "100%", margin: "16px 0" }}>
            <DataGrid
              rows={data}
              columns={productCatalogActionColumns}
              disableRowSelectionOnClick
              disableColumnMenu
              disableColumnSelector
              columnHeaderHeight={80}
              autoPageSize={false}
              showCellVerticalBorder
              showColumnVerticalBorder
              unstable_rowSpanning={false}
              // getEstimatedRowHeight={() => 100}
              getRowHeight={() => "auto"}
              hideFooter
              sx={{
                "& .MuiDataGrid-columnHeaders": {
                  fontWeight: "bold",
                },
                "& .MuiDataGrid-scrollbar": {
                  position: "absolute",
                },
                "& .MuiDataGrid-cell": {
                  padding: "10px 5px",
                },
              }}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ProductCatalogActionFailureReasonModal;
